import { render, staticRenderFns } from "./observe-edit.vue?vue&type=template&id=0ec4ee12&scoped=true&"
import script from "./observe-edit.vue?vue&type=script&lang=js&"
export * from "./observe-edit.vue?vue&type=script&lang=js&"
import style0 from "./observe-edit.vue?vue&type=style&index=0&id=0ec4ee12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec4ee12",
  null
  
)

export default component.exports